module.exports = __webpack_public_path__ + "img/fc.0b46b8f1.jpg";